import { render, staticRenderFns } from "./DownloadBottomSolid.vue?vue&type=template&id=a0b3a828&"
import script from "./DownloadBottomSolid.vue?vue&type=script&lang=ts&"
export * from "./DownloadBottomSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports